<template>
  <div>
  <PlannerHeader id="community-header" class="mb-4" @click="addCommunity" trackClass="add-community-tip">community</PlannerHeader>
  <vx-card v-if="communityTip" class="mt-2 p-2 text-black" collapseAction :startCollapsed="ratingCommunityTip != null" >
      <template v-slot:title>
        <div class="text-left">{{communityTip.title}}</div>
        <div class="text-left text-md mt-1">— {{communityTip.author}}</div>
      </template>
       <div>
        <!-- <div class="text-center text-sm">how enriching is it for you?</div> -->
          <div class="flex justify-center">
            <star-rating class :show-rating="false" @rating-selected="setRatingCommunityTip" v-model="ratingCommunityTip" :star-size="20"></star-rating>
          </div>
        </div>
    </vx-card>


  <PlannerHeader id="wisdom-header" :hide-add="true"  class="mt-16 mb-4">tip <span class="font-normal">#{{tipId+1}}</span></PlannerHeader>
  <vx-card v-if="tip" class=" border border-solid no-shadow text-black p-2" collapseAction :startCollapsed="ratingTip != null">
     <template v-slot:title>
      <div class="xl:flex">

        <div class="w-full xl:w-3/5 flex flex-col justify-center">
          <div class="text-left font-black mb-1 text-xl">
            {{tip.title}}
          </div>

          <div class="text-left">
            {{tip.description}}
          </div>
        </div>

        <div class="flex justify-center mt-4 xl:ml-4 xl:w-2/5 ">
          <img class="lg:w-32 w-48" :src="tip.img">
        </div>

      </div>

    </template>


       <div>
        <!-- <div class="text-center text-sm">how enriching is it for you?</div> -->
        <div class="flex justify-center">
          <star-rating class :show-rating="false" @rating-selected="setRatingTip" v-model="ratingTip" :star-size="20"></star-rating>
        </div>
      </div>
  </vx-card>

  <PlannerHeader id="observation-header" :hide-add="true" class="mt-16 mb-4">wisdom <span class="font-normal">#{{quoteId+1}}</span></PlannerHeader>
  <vx-card v-if="quote" class="mt-2 no-shadow p-2" collapseAction :startCollapsed="ratingQuote != null" cardBackground="#FCFCFC">
      <template v-slot:title>
        <div class="text-center text-black font-black text-lg">„{{quote.title}}“</div>
        <div class="text-right text-gray-50 text-md">— {{quote.author}}</div>
      </template>

       <div>
        <!-- <div class="text-center text-sm">how enriching is it for you?</div> -->
        <div class="flex justify-center">
          <star-rating class :show-rating="false" @rating-selected="setRatingQuote" v-model="ratingQuote" :star-size="20"></star-rating>
        </div>
        </div>
    </vx-card>

  </div>

</template>

<script>

import { QUOTES } from './quotes'
import { TIPS } from './tips'
import { COMMUNITY_TIPS } from './community_tips'
import StarRating from 'vue-star-rating'
// import _ from 'lodash'

export default {
  components: {
    StarRating
  },
  props: {
  },
  data () {
    return {
      ratingQuote: null,
      ratingTip: null,
      ratingCommunityTip: null,
      quoteId: null,
      quote: {},
      tipId: null,
      tip: {},
      communityTipId: null,
      communityTip: {},
      communityTipColor: null
    }
  },
  computed: {
  },
  methods: {
    addCommunity () {
      window.open('https://forms.gle/n843EHK5RvGPMhtH8', '_blank')
    },
    setRatingQuote (rating) {
      this.$store.dispatch('QUOTE_RATED', {id: this.quoteId, rating})
      this.$store.dispatch('ADDITIONAL_USER_INFO', { quoteQated: true })
      console.log('selected: ', rating)
      this.notifier.rated(this.$store)
    },
    setRatingTip (rating) {
      this.$store.dispatch('TIP_RATED', {id: this.tipId, rating})
      this.$store.dispatch('ADDITIONAL_USER_INFO', { tipRated: true })
      console.log('selected: ', rating)
      this.notifier.rated(this.$store)
    },
    setRatingCommunityTip (rating) {
      this.$store.dispatch('COMMUNITY_TIP_RATED', {id: this.communityTipId, rating})
      this.$store.dispatch('ADDITIONAL_USER_INFO', { communityTipRated: true })
      console.log('selected: ', rating)
      this.notifier.rated(this.$store)
    }
  },
  mounted () {
    this.quoteId = this.$store.getters.numberForToday(QUOTES.length)
    this.quote = QUOTES[this.quoteId]
    this.ratingQuote = this.$store.getters.user.ratedQuotes[this.quoteId]

    this.tipId = this.$store.getters.numberForToday(TIPS.length)
    this.tip = TIPS[this.tipId]
    this.ratingTip = this.$store.getters.user.ratedTips[this.tipId]

    this.communityTipId = this.$store.getters.numberForToday(COMMUNITY_TIPS.length)
    this.communityTip = COMMUNITY_TIPS[this.communityTipId]
    this.ratingCommunityTip = this.$store.getters.user.ratedCommunityTips[this.communityTipId]

    const colors = ['#3D3270', '#424CE2', '#2196F3', '#9C28B1', '#E91D62', '#F34336', '#FFB800', '#21C228']
    this.communityTipColor = colors[(this.$store.getters.user.activeDays || 0) % colors.length]
  }
}

</script>


<style scoped lang="scss">
</style>
